import axiosInstance from '../axiosInterceptor/axiosInstance'

const deleteStage = async ({ orgId, stageId }) => {
  const url = `v1/orgs/${orgId}/stages/${stageId}`
  const response = await axiosInstance.delete(url)
  return response?.data
}

export default deleteStage
